<template>
  <div class="footBar">
    <div class="moreFootView flex_g between">
      <div class="moreFootItem">
        <div class="footCaption">图推理机</div>
        <div class="footMoreContent footMoreHover">
          图推理机是什么
        </div>
        <div class="footMoreContent footMoreHover">
          为什么选择图推理机
        </div>
        <div class="footMoreContent footMoreHover" @click="jumpToPage('/demonstration')">
          线上演示
        </div>
      </div>
      <div class="moreFootItem">
        <div class="footCaption">资料</div>
        <div class="footMoreContent footMoreHover" @click="jumpToPage(
          'https://github.com/starry-graph/FanXingFund-TemporalGraph',
          JumpActions.OPENS_AT_NEW_WINDOW
        )">
          源码
        </div>
        <!-- <div class="footMoreContent footMoreHover"
          @click="jumpToPage('/document')">
          文档
        </div> -->
        <div class="footMoreContent footMoreHover" @click="jumpToPage('/dataSet')">
          数据集下载
        </div>
      </div>
      <div class="moreFootItem">
        <div class="footCaption">联系我们</div>
        <!--<div class="footMoreContent">021-55698603</div>-->
        <div class="footMoreContent">starrygraph@zju.edu.cn</div>
      </div>
      <div class="moreFootItem">
        <img class="mainLogo" src="@/assets/images/logo_white.png" />
      </div>
    </div>
    <div class="moreLink flex_g vertical">
      <!-- <img src="" alt="">
            <img src="" alt="">
            <img src="" alt="">
            <img src="" alt="">
            <img src="" alt=""> -->
    </div>
    <div class="footTip">
      <p>© 2004-2024 上海浙江大学高等研究院 </p>
      <!--<p>-->
          <!--<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502019924"-->
            <!--style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">-->
            <!--<img src="@/assets/images/beian.png" style="float:left;"/>-->
              <!--<font color="#ffffff">沪公网安备 31011502019924号</font></a>  沪ICP备2021025709号-3</p>-->
    </div>


  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // Constants
      JumpActions: {
        PUSHES_TO_ROUTER: 1,
        OPENS_AT_NEW_WINDOW: 2
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    jumpToPage(url, action) {
      // Default action
      if (!action) {
        action = this.JumpActions.PUSHES_TO_ROUTER;
      }
      if (action == this.JumpActions.PUSHES_TO_ROUTER) {
        this.$router.push({
          path: url
        });
      } else {
        window.open(url, "_blank");
      }
    }
  },
  created() { },
  mounted() { }
}
</script>
<style lang="scss" scoped>
.footBar {
  background: #26292e;
  padding: 5rem 18% 2.5rem;
  position: relative;
  z-index: 15;

  .moreFootView {
    margin-bottom: 3rem;

    .moreFootItem {
      .footCaption {
        margin-bottom: 0.8rem;
        font-size: 1.07rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 1.5rem;
      }

      .footMoreContent {
        font-size: 0.93rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 2.14rem;
        opacity: 0.4;
      }

      .footMoreHover:hover {
        opacity: 1;
        cursor: default;
      }

      .mainLogo {
        width: 10rem;
        height: 3rem;
        margin-bottom: 2rem;
        display: block;
      }

      .subLogo {
        width: 12.36rem;
        height: 3.79rem;
        display: block;
      }
    }
  }

  .moreLink {
    margin-bottom: 3rem;

    img {
      width: 1.8rem;
      height: 1.8rem;
      background: #eee;
      margin-right: 1rem;
    }
  }

  .footTip {
    text-align: center;
    font-size: 1rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 1.83rem;
    opacity: 0.4;
  }
}
</style>